<template>
  <div class="infor evInfor">
    <div class="header-dialog" v-if="headerName.includes('网关')">
      <div class="top-name">
        <div class="name">{{ headerName }}</div>
        <div @pointerdown="clickClose" class="imgbg"></div>
      </div>
      <div class="middle-name">
        <div class="left-text">{{ pannelDatas.name }}</div>
        <div class="right-status">
          {{ "固定版本" }} <span>{{ pannelDatas.version }}</span>
        </div>
      </div>
      <div class="line-middle1"></div>
      <div class="line-middle2"></div>
    </div>

    <!-- <div class="header-dialog" v-else>
      <div class="top-name">
        <div class="name">{{ headerName }}</div>
        <div @pointerdown="clickClose" class="imgbg"></div>
      </div>
      <div class="car-infor">
        <div class="car-text">车位编号</div>
        <div class="car-number" v-if="number.includes('人')">
          <div class="number_text">{{number.slice(0,2)}}</div>
          <div>{{number.slice(2)}}</div>
        </div>
        <div class="car-number">{{ number }}</div>
      </div>
      <div class="line-middle1"></div>
      <div class="line-middle2"></div>
    </div> -->

    <div class="header-dialog" v-else>
      <div class="top-name">
        <div class="name">{{ headerName }}</div>
        <div @pointerdown="clickClose" class="imgbg"></div>
      </div>
    </div>
    <pannel-data :pannelDatas="pannelDatas" :carUrl="carUrl"> </pannel-data>
  </div>
</template>

<script>
import pannelData from "./components/pannel-data.vue";
export default {
  name: "gate-way",
  components: { pannelData },
  props: {
    headerName: String,
    pannelDatas: Object,
    number: String,
    carUrl:Object
  },
  data() {
    return {
      isshow: false,
      statusMap: ["停用", "正常", "故障"],
    };
  },
  methods: {
    // 点击关闭
    clickClose() {
      this.$parent.showDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.infor::before {
  content: "";
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
  background: inherit;
}

.infor {
  pointer-events: all;
  width: 381px;
  min-height: 375px;
  // background-size: cover;
  // background-image: url("../../assets/cut/newdialodbg-bg.png");
  border-image: url("../../assets/cut/backimg-normal.png");
  border-image-slice: 55 166 75 65 fill;
  border-image-width: 20px 50px 20px 20px; // 设置各个区域的图片宽度
  border-image-repeat: repeat; // 图片重复或拉伸模式
  // border-image-outset: 10px 10px 10px 10px; //
  color: #fff;

  .header-dialog {
    .middle-name {
      justify-content: space-between;
      color: #fff;
      font-size: 14px;
      padding: 20px;
      margin: 0;
      .right-status {
        // width: 144px;
        height: 21px;
        font-size: 14px;
        line-height: 21px;
        color: rgba(239, 239, 239, 0.7);
        display: flex;
        span {
          color: #fff;
          margin-left: 10px;
        }
      }
    }
    .car-infor {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 20px;
      .car-text {
        color: rgba(239, 239, 239, 0.7);
      }
      .car-number {
        display: flex;
        font-family: "Source Han Sans CN";
        margin-left: 20px;
        font-size: 20px;
        height: 30px;
        line-height: 30px;
        .number_text {
          // font-size: 18px;
        }
      }
    }
    .line-middle1 {
      margin: 0 20px;
      width: 341px;
      height: 1px;
      background: rgba(217, 217, 217, 0.1);
    }
    .line-middle2 {
      margin: 0 20px;
      width: 341px;
      height: 1px;
      background: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
